export default "__VITE_ASSET__4LByz8c8__"